import intlTelInput from 'intl-tel-input';
import swal from "sweetalert";
import MicroModal from 'micromodal'
declare var jQuery:any;
declare var admin_var:any;

export class Login {
    id:string
    constructor(id:string) {
        this.id = id;
        this.start_listeners();
        let phonesInputs:any = jQuery("input[type='tel'], input.js-phoneInput");
        let emailsInputs:any = jQuery("input[type='email'], input.js-email");
        phonesInputs.each((_:number, input:any) => {
            let inputId:string = input.id;
            let classesInput:string = "";
            input.id = input.id + '_tel_input'
            input.name = input.name + '_tel_input'
            if (jQuery(input).hasClass('login_input')) {
                classesInput = "class='login_input js-phoneInput'";
            }
            jQuery(input).after("<input type='hidden' "+classesInput+" id='"+inputId+"' name='"+inputId+"' value='"+jQuery(input).val()+"'/>")
            let inputPhone:any = intlTelInput(input, {
                initialCountry: "ca",
                autoPlaceholder: "aggressive",
                utilsScript: "utils.js"
            });
            jQuery(input).on('keypress', (e:any) => {
                return this.updatePhoneInput(e);
            }).on('blur', (e:any) => {
                jQuery('#'+inputId).val(inputPhone.getNumber());
                if (jQuery(e.target).val() != '' && !inputPhone.isValidNumber()) {
                    jQuery(e.target).addClass('input-wrong');
                    jQuery('#billing_phone_tel_input-error')
                    .text('Invalid phone')
                    .show();             
                    jQuery(e.target).css('border', '1px red solid');
                } else {
                    jQuery(e.target).removeClass('input-wrong');
                    jQuery(e.target).css('border', '');
                    jQuery('#billing_phone_tel_input-error')
                    .text('')
                    .hide();
                
                }
            });
            jQuery(inputPhone.countryList).find('li').on('click', (e:any) => {
                jQuery(inputPhone.telInput).val('');
            })
            let placeholder:string = jQuery(input).attr('placeholder');
            let currValue:string = jQuery(input).val().replace(/[^0-9]/g,"");
            this.convertPhoneFormat(jQuery(input), currValue, placeholder);
        });
        MicroModal.init();
    }

    public start_listeners() {
        jQuery('#login-modal, #login-modal-min').on('click', (event:any) => {
            event.preventDefault();
            event.target.blur(); // Manually remove focus from clicked link.
            MicroModal.show('login_modal', {
                onClose: (modal:any) => {
                    this.resizeModal('login_form');
                    this.switchTab(jQuery('div[data-tab="login_form"]'), 'login_form');
                }
            });
        });
        jQuery('#'+this.id+' div[data-tab]').on('click', (event:any) => {
            event.preventDefault();
            let tab:string = jQuery(event.target).data('tab');
            this.resizeModal(tab);
            this.switchTab(event.target, tab);
        });
        // jQuery('#login_form').on('submit', (event:any) => {
        //     event.preventDefault();
        //     this.showLoader(true);
        //     this.submitLogin(event.target);
        //     event.stopImmediatePropagation();
        // });
        // jQuery('#register_form').on('submit', (event:any) => {
        //     event.preventDefault();
        //     this.showLoader(true);
        //     this.submitRegistration(event.target);
        //     event.stopImmediatePropagation();
        // });

        jQuery('#login-btn').on('click', (e:any) => {
            const str_username_email = jQuery('input[name="str_username_email"]').val();
            const str_password = jQuery('input[name="str_password"]').val();
            if (str_username_email && str_password) {
                jQuery('.login--inline-loader-overlay').show();
                jQuery('.login--inline-loader-overlay').css({
                    'display': 'flex',
                    'align-items': 'center',
                    'justify-content': 'center'
                });                
            }
        });
    }

    private switchTab(target:any, tab:string) {
        jQuery('#'+this.id+' div[data-tab]').addClass('disabled');
        jQuery(target).removeClass('disabled');
        jQuery('.login_form').addClass('disabled');
        jQuery('#' + tab).removeClass('disabled');
        jQuery('.login_form input.login_input').val('');
        jQuery('.login_form select.modal-dropdown').prop('selectedIndex',0);
        jQuery('.login_form .modal-options-row input[type="checkbox"]').prop( "checked", false );
        jQuery('.login_form .modal-options-row input[type="radio"]').prop( "checked", false );
    }

    private resizeModal(tab:string) {
        let needResize = jQuery('.modal_container.need-double').length > 0;
        if (needResize) {
            if (tab == 'register_form') {
                jQuery('.modal_container.need-double').addClass('double-size');
            } else {
                jQuery('.modal_container.need-double').removeClass('double-size');
            }
        }
    }

    private showLoader(show:boolean) {
        if (show) {
            jQuery('.loader_background').addClass('show');
        } else {
            jQuery('.loader_background').removeClass('show');
        }
    }

    private submitLogin(target:any){
        let $form:any = jQuery( target );
        let username:string = $form.find( "#name" ).val();
        let password:string = $form.find( "#password" ).val();
        let login:any = jQuery.post( admin_var.admin_post, {action: "fr_login", username: username, password: password} );
        login.done(( data:any ) => {
            let json_resp:any = JSON.parse(data);
            if (!json_resp.success) {
                this.showLoader(false);
                $form.find( "#name" ).val('');
                $form.find( "#password" ).val('');
                MicroModal.close();
                var pel:any = document.createElement('div');
                pel.innerHTML = json_resp.message;
                swal({
                    title: 'Log In',
                    content: pel,
                    icon: "warning"
                })
                return;
            }else{
                window.location.replace(json_resp.redirect);
            }
            // location.reload();
        });
    }

    private submitRegistration(target:any){
        let $form:any = jQuery( target );
        let validate = [{
            "msg": '',
            "val": false,
        }];

        validate[0] = this.validateRegisterFields($form);

        if ($form.find('input.login_input.input-wrong').length > 0) {
            return false;
        }

        let inputs:any = $form.find('input.login_input');
        let data:any = {};
        let count_required = 0;
        inputs.css('border', '');
        inputs.each((_:number, elem:any) => {
            let valid:boolean = false;
            if (elem.required) {
                count_required ++;
            }

            if (elem.value) {
                let classType:string = '';
                elem.classList.forEach((className:string) => {
                    if (className.startsWith('js-')) {
                        classType = className;
                        return
                    }
                });
                if (this.validateText(elem.value, classType)) {
                    data[elem.id] = elem.value;
                    valid = true;
                }
            }
            if (!valid) {
                if (elem.required) {
                    jQuery(elem).css('border', '1px red solid');
                }
            }
        })
        let radio:any = $form.find('.modal-radio-group');
        radio.each((_:number, elem:any) => {
            if (elem.required) {
                count_required ++;
            }
            let radioValue:string = '';
            radio.find('input[type="radio"]').each((_:number, radioBtn:any) => {
                if(radioBtn.checked) {
                    radioValue = jQuery(radioBtn).val();
                }
            });
            data[elem.id] = radioValue;
        });
        let checkboxes:any = $form.find('.modal-multiple-choice-group');
        checkboxes.each((_:number, elem:any) => {
            if (elem.required) {
                count_required ++;
            }
            let checkboxValue:string[] = []
            checkboxes.find('input[type="checkbox"]').each((_:number, checkboxBtn:any) => {
                if(checkboxBtn.checked) {
                    checkboxValue.push(checkboxBtn.id);
                }
            });
            if (checkboxValue.length > 0) {
                data[elem.id] = checkboxValue;
            } else {
                if (elem.required) {
                    jQuery(elem).css('border', '1px red solid');
                }
            }
        });
        let dropdown:any = $form.find('.modal-dropdown');
        dropdown.each((_:number, elem:any) => {
            if (elem.required) {
                count_required ++;
            }
            if (elem.value) {
                data[elem.id] = elem.value;
            } else {
                if (elem.required) {
                    jQuery(elem).css('border', '1px red solid');
                }
            }
        });
        if(validate[0].val){
            data['action'] = "autologinRegistration";
            var register:any = jQuery.post( admin_var.ajax_url, data);
            register.done(( data:any ) => {
                let json_resp:any = JSON.parse(data);
                if (!json_resp.success) {
                    this.showLoader(false);
                    if (json_resp.message == 'User not active.') {
                        swal({
                            title: 'Check your email to activate your user.',
                        })
                    }else if(json_resp.message == 'This email is already in use. Try again or click Forgot password to reset it.'){
                        swal({
                            text: json_resp.message,
                            icon: "warning"
                        })
                    }else{
                        MicroModal.close();
                        swal({
                            text: 'Success',
                            icon: "success"
                        }).then(function(){
                            location.reload();
                        })
                    }
                }
            });
        }else{
            swal({
                title: 'Error',
                text: validate[0].msg,
                icon: "warning"
            })
        }
    }

    private validateText(value:string, type:string) {
        switch (type) {
            case 'js-emailInput':
                if (value.length < 6) {
                    return false;
                }
                let re_email:any = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re_email.test(value);
            case 'js-dateInput':
                let d:any = new Date(value);
                if (!d.valueOf()) {
                    return false;
                }
                break;
        }
        return true;
    }

    private updatePhoneInput(e:any) {
        let charCode:any = (e.which) ? e.which : e.keyCode;
        if (String.fromCharCode(charCode).match(/[^0-9.]/g)) {
            return false;
        }

        let placeholder:string = jQuery(e.target).attr('placeholder');
        let currValue:string = jQuery(e.target).val().replace(/[^0-9]/g,"");
        if (e.target.selectionStart == e.target.selectionEnd) {
            if (placeholder.replace(/[^0-9]/g,"").length <= currValue.length) {
                return false;
            }
        }
        this.convertPhoneFormat(jQuery(e.target), currValue, placeholder);

        return true;
    }

    private convertPhoneFormat(elem:any, currValue:string, placeholder:string) {
        let i:number = 0;
        let j:number = 0
        let newValstring = "";
        for (i = 0; i < placeholder.length; i++) {
            if (j >= currValue.length) {
                break;
            }
            if (isNaN(parseInt(placeholder[i]))) {
                newValstring += placeholder[i];
            } else {
                newValstring += currValue[j];
                j++;
            }
        }
        elem.val(newValstring);
    }

    private validateRegisterFields(form:any){
        let password = form.find('input#password').val();
        let valPassword = form.find('input#password_validate').val();
        let email = form.find('input#email').val();
        let valEmail = form.find('input#email_validate').val();
        let validation = true;
        let errMsg = '';
        var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if(validation){
            if(!(password === valPassword)){  errMsg='Password fields are not the same. Try again.'; validation = false}
        }

        if(validation){
            if(!filter.test(email)) {  errMsg='Email Invalid*'; validation = false; }
            else if(!(email === valEmail)){ errMsg='Email fields are not the same. Try again.'; validation = false;}
        }

        const validate = {msg: errMsg, val: validation}

        return validate;
    }
}


jQuery( document ).ready(function($:any) {
    let mainClass: Login = new Login('login_modal');
    mainClass.start_listeners();
});
